import apiClient, { unwrap } from './client'

export interface ComposeAttachment {
  filename: string
  content_type?: string
  /** base64 编码的文件内容 */
  data: string
}

export interface ComposeSendRequest {
  /** 发件邮箱（必须为本地已存在且启用的邮箱） */
  from: string
  /** 收件人（To） */
  recipients: string[]
  /** 抄送（Cc） */
  cc?: string[]
  /** 密送（Bcc） */
  bcc?: string[]
  subject: string
  body_html?: string
  body_text?: string
  attachments?: ComposeAttachment[]
  /** 分别发送：true 时每位 To 各收独立一封；false（默认）合并为一封 */
  send_separately?: boolean
}

export interface ComposeSendResult {
  subject: string
  total: number
  sent: number
  failed: number
  results: { recipient: string; status: string; error?: string }[]
}

export const composeApi = {
  send(req: ComposeSendRequest) {
    return unwrap<ComposeSendResult>(apiClient.post('/compose/send', req))
  },
}
